import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Return = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Return' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M9,4 L4,9 L9,14 M18,19 L18,9 L5,9' transform='matrix(1 0 0 -1 0 23)' />
  </StyledIcon>
);
